/**
 * Hamburger Toggle in SP
 */
const hamburgerToggle = () => {
  const hamburger = document.querySelector('.js-hamburger');
  const nav = document.querySelector('.js-nav');
  const body = document.querySelector('body');
  const navItems = document.querySelectorAll('.js-navitem');

  if (nav && hamburger && body) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('active');
      nav.classList.toggle('active');
      body.classList.toggle('disable-scroll');
    });

    navItems.forEach(element => {
      element.addEventListener('click', function () {
        hamburger.classList.remove('active');
        nav.classList.remove('active');
        body.classList.remove('disable-scroll');
      });
    });
  }
};

export default hamburgerToggle;
